document.addEventListener('DOMContentLoaded', function() {
    var tags = document.querySelectorAll('.fadeinitem');
    
    if (tags.length > 0) {
        window.addEventListener('scroll', function() {
            var pageTop = window.pageYOffset || document.documentElement.scrollTop;
            var pageBottom = pageTop + window.innerHeight;
    
            tags.forEach(function(tag) {
                var isTagVisible = tag.classList.contains('visible');
    
                if (tag.getBoundingClientRect().top < pageBottom && !isTagVisible) {
                    tag.classList.add('visible');
                    tag.reached = true;
                } else if (tag.getBoundingClientRect().top >= pageBottom && isTagVisible) {
                    tag.classList.remove('visible');
                    tag.reached = false;
                }
            });
        });
    }
});